// PaperPilot i18n — Korean (default) and English UI strings.
// Technical content (paper titles, authors, abstracts, equations) stays English
// — Korean researchers work with English-language papers.

const I18N = {
  ko: {
    // brand / shell
    'brand.tagline': '연구 OS',
    'nav.section.workspace': '워크스페이스',
    'nav.section.projects': '프로젝트',
    'nav.dashboard': '대시보드',
    'nav.explore': '탐색',
    'nav.library': '내 서재',
    'nav.bench': '벤치마크 메모리',
    'nav.projects': '프로젝트',
    'nav.graph': '지식 그래프',
    'nav.wiki': '연구 위키',
    'nav.reports': '리포트',
    'nav.assistant': 'AI 어시스턴트',
    'nav.questions': '내 Q&A',
    'nav.integrations': '연동',
    'nav.settings': '설정',
    'user.role': '로보틱스 · KAIST',

    // top bar
    'cmd.placeholder': '서재 전체에 무엇이든 물어보세요…',
    'cmd.mode': '시맨틱',
    'cmd.import': '가져오기',
    'cmd.synced': '동기화됨 · 09:42',

    // crumbs
    'crumb.workspace': '워크스페이스',
    'crumb.dashboard': '대시보드',
    'crumb.explore': '탐색',
    'crumb.wiki': '위키',
    'crumb.graph': '지식 그래프',
    'crumb.bench': '벤치마크 메모리',
    'crumb.assistant': 'AI 어시스턴트',
    'crumb.newconv': '새 대화',
    'crumb.projects': '프로젝트',

    // dashboard
    'dash.greeting': '좋은 아침이에요, 우니님!',
    'dash.greeting.sub': (a, b, c) => <>어제 이후 추적 토픽 9개에서 <span className="mono" style={{ color: 'var(--acc-violet)' }}>{a}</span>편의 새 논문이 도착했습니다. 진행 중인 프로젝트와 매칭된 것은 <span className="mono" style={{ color: 'var(--acc-indigo)' }}>{b}</span>편, "꼭 읽기" 표시는 <span className="mono" style={{ color: 'var(--acc-cyan)' }}>{c}</span>편 — 예상 소요 <span style={{ color: 'var(--fg-0)' }}>52분</span>.</>,
    'dash.yesterday': '어제',
    'dash.filters': '필터 · 6',
    'dash.generate': '브리핑 생성',
    'kpi.new': '오늘 신규',
    'kpi.unread': '미독 중요',
    'kpi.bench': '벤치마크 업데이트',
    'kpi.citation': '인용 알림',
    'kpi.code': '코드 공개',
    'kpi.project': '프로젝트 관련',
    'kpi.delta.vs': '어제 대비',
    'dash.s1.kicker': '01 / 오늘',
    'dash.s1.title': '꼭 읽기 큐',
    'dash.s1.sub': 'AI 선별, 관련도 × 새로움 × 시급도 순',
    'dash.s1.count': '3편 · 52분',
    'dash.seeall': '전체 보기',
    'dash.s2.kicker': '02 / 오늘',
    'dash.s2.title': '추천 논문',
    'dash.s2.sub': '내 프로젝트와의 근접도 기준 · 추천 근거는 아래',
    'dash.s3.kicker': '03',
    'dash.s3.title': '트렌딩 토픽 · 7일',
    'dash.s3.unit': '편/일',
    'dash.s4.kicker': '04',
    'dash.s4.title': '오늘 공개된 코드',
    'dash.s4.unit': '9개 저장소',
    'rail.resume.kicker': '이어서',
    'rail.resume.title': '읽던 곳부터',
    'rail.resume.where': 'p. 7 / 23 · §3.2 Action tokenization',
    'rail.follow.kicker': '팔로업',
    'rail.follow.title': '저장 · 후속 조치 필요',
    'rail.follow.r1.title': 'Gaussian-Splatting SLAM',
    'rail.follow.r1.reason': '이번 주 3회 인용됨',
    'rail.follow.r2.title': 'MobileVLA: 1.5B on-device',
    'rail.follow.r2.reason': '어제 v2 공개',
    'rail.follow.r3.title': 'EvalRobotics-v3 protocol',
    'rail.follow.r3.reason': '새 데이터셋 링크',
    'rail.pulse.kicker': '리듬',
    'rail.pulse.title': '주간 연구 모멘텀',
    'rail.pulse.unit': '편 / 주',
    'rail.pulse.note': '4DGS +62%, VLA +48% (전주 대비)',
    'rail.ask.kicker': 'AI',
    'rail.ask.title': '어시스턴트에게 묻기',
    'rail.ask.suggest': '오늘의 제안 질문',
    'rail.ask.q1': 'D-NeRF에서 GS-DiT와 4DGS-Cache를 공정 비교',
    'rail.ask.q2': 'OpenVLA-2는 v1 대비 무엇이 바뀌었나',
    'rail.ask.q3': '이번 주 4DGS 논문 요약',
    'rail.ask.input': '서재 전체에 질문…',

    // paper card
    'pc.must': '꼭 읽기',
    'pc.code': '코드',
    'pc.code.soon': '곧',
    'pc.why': '추천 근거',
    'pc.score.worth': '가치',
    'pc.score.novel': '새로움',
    'pc.score.impl': '구현',
    'pc.action.bookmark': '북마크',
    'pc.action.addproject': '프로젝트 추가',
    'pc.action.compare': '비교',
    'pc.action.openpdf': 'PDF 열기',

    // explore
    'exp.filters': '필터',
    'exp.reset': '초기화 6',
    'exp.qmode': '쿼리 모드',
    'exp.qmode.semantic': '시맨틱',
    'exp.qmode.keyword': '키워드',
    'exp.qmode.hybrid': '하이브리드',
    'exp.date': '기간',
    'exp.topic': '토픽',
    'exp.topic.selected': '4개 선택됨',
    'exp.venue': '학회',
    'exp.method': '방법',
    'exp.dataset': '데이터셋',
    'exp.signals': '시그널',
    'exp.signal.os': '오픈소스만',
    'exp.signal.real': '실로봇 평가',
    'exp.signal.bookmark': '북마크됨',
    'exp.signal.unread': '미독만',
    'exp.signal.inproj': '내 프로젝트',
    'exp.scores': '점수',
    'exp.score.worth': '읽을 가치',
    'exp.score.novel': '새로움',
    'exp.score.impl': '구현 가치',
    'exp.results': '3,248건',
    'exp.results.meta': (s) => <>매칭 시간 <span className="mono" style={{ color: 'var(--acc-indigo)' }}>{s}</span> · 시맨틱 + 필터 · 4DGS, deformation field, 실로봇 평가</>,
    'exp.view.cards': '카드',
    'exp.view.table': '표',
    'exp.sort': '정렬: 관련도 × 새로움',
    'exp.compare': '비교 (3)',
    'exp.loadmore': '나머지 3,242건 더보기',
    'exp.preview': '미리보기',
    'exp.preview.glance': '한눈에',
    'exp.preview.worth': '읽을 가치가 있나?',
    'exp.eval.relevance': '관심 분야 적합도',
    'exp.eval.novelty': '새로움',
    'exp.eval.impl': '구현 가치',
    'exp.eval.signif': '연구 의의',
    'exp.eval.diff': '난이도',
    'exp.preview.connect': '내 연구와의 연결',
    'exp.preview.bench': '벤치마크 스냅샷',
    'exp.preview.bench.vs': '대비',
    'exp.preview.bench.speedup': '배 빠름',
    'exp.preview.open': '상세 보기',

    // detail
    'det.peer': '동료검토 완료',
    'det.top': '상위 3% 예측',
    'det.coderel': '코드 공개됨',
    'det.openpdf': 'PDF 리더 열기',
    'det.save': '저장',
    'det.addproj': '프로젝트 추가',
    'det.compare': '비교',
    'det.cite': '인용 · BibTeX',
    'det.repo': '저장소',
    'det.tab.overview': '개요',
    'det.tab.summary': 'AI 요약',
    'det.tab.why': '추천 근거',
    'det.tab.critique': '비평',
    'det.tab.novelty': 'Novelty 분해',
    'det.tab.qa': 'Q&A (5)',
    'det.tab.related': '관련 논문',
    'det.tab.notes': '노트 (8)',
    'det.tab.bench': '벤치마크 (5)',
    'det.tab.code': '코드',
    'det.tab.proj': '프로젝트 적합도',
    'det.tab.order': '읽기 순서',
    'det.eval.title': '읽을 가치가 있나?',
    'det.eval.sub': '내 독서 이력 및 프로젝트와 대조한 구조화 평가',
    'det.eval.relevance': '관련도',
    'det.eval.novelty': '새로움',
    'det.eval.impl': '구현 가치',
    'det.eval.signif': '연구 의의',
    'det.eval.impact': '예상 영향력',
    'det.eval.diff': '읽기 난이도',
    'det.eval.note.rel': '9/10 · 서버랙 디지털 트윈에 근접',
    'det.eval.note.nov': 'DiT prior + GS 변형은 신규',
    'det.eval.note.imp': '저장소 공개, 단일 4090에서 가능',
    'det.eval.note.sig': 'D-NeRF SoTA 갱신',
    'det.eval.note.impact': '18개월 내 240회 인용 추정',
    'det.eval.note.dif': 'ML+그래픽스 사전 지식 필요',
    'det.rec.headline': '오늘 읽으세요 — 4D 재구성/랙 트윈에 영향 큼.',
    'det.rec.sub': '52분 · 시간 부족 시 §4.3 생략; §3 + §5.2가 핵심',
    'det.rec.add': '오늘 큐에 추가',
    'det.why.title': '이 논문이 추천된 이유',
    'det.why1.title': '진행 중 프로젝트 매칭: 서버랙 디지털 트윈',
    'det.why1.body': '얇은 금속 형상(D-NeRF 베이스라인의 알려진 실패 모드)을 처리하고 84 FPS에 도달 — 30Hz 인터랙티브 트윈 예산에 2.8× 여유.',
    'det.why2.title': '연구 위키 스레드 연속: deformation field',
    'det.why2.body': '논문의 canonical-to-frame deformation 정식화가 위키의 Deformable-3DGS (3/4 저장) 및 Park 외 (지난주 저장) 주석과 일치.',
    'det.why3.title': '내 북마크 3편이 본 논문을 선행 연구로 인용',
    'det.why3.body': 'OpenVLA-2, RoboFM-13B, 4DGS-Cache (읽기 큐) 모두 GS-DiT deformation 캐시를 참조.',
    'det.why4.title': '팔로우 중인 저자 Mildenhall 참여',
    'det.why4.body': '최근 12개월 4편, 평균 가치 점수 0.84.',
    'det.order.title': '읽기 순서',
    'det.order.sub': '선행/후행 순서, 선수 강도 기준',
    'det.order.before': '먼저 읽을 것',
    'det.order.after': '이후 읽을 것',
    'det.order.tag.prereq': '선수',
    'det.order.tag.prior': '선행 연구',
    'det.order.tag.follow': '후속',
    'det.order.tag.crit': '비판',
    'det.order.tag.app': '응용',
    'det.order.read': '읽음',
    'det.order.unread': '미독',
    'det.order.queue': '읽기 큐',
    'det.bench.title': '관련 벤치마크 결과',
    'det.bench.open': '벤치마크 메모리에서 열기',
    'det.bench.col.method': '방법',
    'det.bench.col.dataset': '데이터셋',
    'det.bench.col.cond': '조건',
    'det.bench.col.code': '코드',
    'det.rail.sum': 'AI 요약 · 60초',
    'det.rail.conn': '내 연구와의 연결',
    'det.rail.meth': '방법론',
    'det.rail.res': '리소스',
    'det.rail.training': '28k 클립 학습 · MVS 전처리 · L1 + LPIPS + flow consistency',

    // reader
    'rd.diff': '난이도 7/10',
    'rd.timeleft': '~18분 남음',
    'rd.outline': '아웃라인',
    'rd.find': '찾기',
    'rd.figs': '그림 · 14',
    'rd.outline.btn': '아웃라인',
    'rd.pop.high': '하이라이트',
    'rd.pop.simple': '쉽게 설명',
    'rd.pop.formula': '수식 설명',
    'rd.pop.impl': '구현 해석',
    'rd.pop.related': '관련 연구',
    'rd.pop.wiki': '위키로 저장',
    'rd.pop.proj': '프로젝트로 추가',
    'rd.tab.ai': 'AI',
    'rd.tab.notes': '노트',
    'rd.tab.high': '하이라이트',
    'rd.tab.figs': '그림',
    'rd.tab.tabs': '표',
    'rd.ai.kicker': '구현 해석',
    'rd.ai.body.lead': '코드 관점에서:',
    'rd.ai.body': ' 학습 시에는 일반 MLP $$g_θ(id, t)$$를 유지하고, 학습 종료 시점에 모든 (id, t) 쌍을 스윕하여 4-bit 코드북(약 64 엔트리)으로 양자화한 뒤 Gaussian별 인덱스 맵에 저장합니다. 추론 시에는 단일 텍스처 페치로 — MLP 순전파 없이 — 끝나므로 FPS가 3.1× 상승합니다.',
    'rd.copy': '복사',
    'rd.save.wiki': '위키로 저장',
    'rd.pin.proj': '프로젝트에 고정',
    'rd.formula.kicker': '수식 · eq. 7',
    'rd.formula.body': 'canonical 위치에 id·시간별 변위를 더한 것. 캐시는 코드북 룩업으로 변위를 근사합니다.',
    'rd.related.title': '관련 (이 단락에서)',
    'rd.related.r1': 'Eq. 4 출처로 인용됨',
    'rd.related.r2': '대안 변형 방식',
    'rd.related.r3': '캐시 아이디어를 확장',
    'rd.memo.kicker': '내 메모 · 2분 전',
    'rd.memo.body': '랙 데이터셋 3주차에 시도 — 케이블 영역 800개+ Gaussian에 대해 4-bit 코드북이 유지되는지 확인. Park 24 베이스라인 대비 비교.',
    'rd.ask.passage': '이 단락에 대해 질문…',

    // bench
    'bn.dataset': '데이터셋',
    'bn.task': '과제',
    'bn.metric': '지표',
    'bn.cond': '조건',
    'bn.method': '방법',
    'bn.venue': '학회',
    'bn.year': '연도',
    'bn.all': '전체',
    'bn.any': '전부',
    'bn.code': '코드 공개',
    'bn.verified': '검증된 결과만',
    'bn.real': '실로봇만',
    'bn.fair': '공정 비교',
    'bn.view.table': '표',
    'bn.view.leader': '리더보드',
    'bn.view.compare': '비교',
    'bn.results': '87건',
    'bn.results.sub': '논문 23편, 데이터셋 2개, 조건 3개',
    'bn.stat.verified': '검증',
    'bn.stat.auto': '자동 추출',
    'bn.stat.corrected': '사용자 보정',
    'bn.stat.fair': '공정 비교 경고',
    'bn.group': '데이터셋별 그룹',
    'bn.export': 'CSV 내보내기',
    'bn.compare3': '비교 (3)',
    'bn.col.method': '방법',
    'bn.col.paper': '논문',
    'bn.col.metric': '지표',
    'bn.col.value': '값',
    'bn.col.delta': '최고 대비',
    'bn.col.code': '코드',
    'bn.col.source': '출처',
    'bn.col.conf': '신뢰',
    'bn.col.status': '상태',
    'bn.row.results': '건',
    'bn.status.verified': '검증',
    'bn.status.corrected': '보정',
    'bn.status.fair': '공정-비교',
    'bn.status.auto': '자동',
    'bn.rail.detail': '결과 상세',
    'bn.rail.cond': '조건 · 추출됨',
    'bn.rail.cond.views': '입력 뷰',
    'bn.rail.cond.frames': '프레임',
    'bn.rail.cond.res': '해상도',
    'bn.rail.cond.split': '분할',
    'bn.rail.cond.hw': '하드웨어',
    'bn.rail.cond.pre': '사전학습',
    'bn.rail.cond.views.v': '입력 8개 뷰',
    'bn.rail.cond.frames.v': '씬당 200',
    'bn.rail.cond.split.v': 'canonical, D-NeRF v2',
    'bn.rail.cond.hw.v': '1 × RTX 4090',
    'bn.rail.cond.pre.v': '28k 클립 · 112M params',
    'bn.rail.evidence': '출처 근거',
    'bn.rail.openpdf': 'PDF 리더에서 페이지 열기',
    'bn.rail.fair.kicker': '공정 비교 노트',
    'bn.rail.fair.body': '4DGS-Cache는 120 FPS를 보고하지만 Tbl. 1에서 800×800이 아닌 600×600 해상도입니다. 800×800에서 재렌더 시 비교 가능한 값은 72 FPS이며, 표준 해상도 기준 GS-DiT가 가장 빠릅니다.',
    'bn.rail.ai': 'AI 해석',
    'bn.rail.ai.body': '개선의 거의 전부는 diffusion-prior 사전학습에서 발생 (+0.9 PSNR, §5.2에서 ablate); canonical-id 캐시는 속도 전용입니다. 28k 클립 사전학습 코퍼스 없이 재현 시 Def-3DGS에 근접한 결과 예상.',

    // projects
    'proj.triaged': '논문 분류 042 / 240',
    'proj.ontrack': '정상 진행',
    'proj.started': '시작 2025년 2월',
    'proj.collab': '공동 작업자',
    'proj.newpapers': '마지막 방문 후 새 논문',
    'proj.benchref': '벤치마크 참조 연결',
    'proj.add': '논문 추가',
    'proj.askai': 'AI에 묻기',
    'proj.generate': '브리핑 생성',
    'proj.direction': 'AI 프로젝트 방향 요약',
    'proj.direction.body': () => <>본 프로젝트는 <span style={{ color: 'var(--fg-0)' }}>얇은 금속 형상용 실시간 4DGS</span>에 집중. 분류된 42편 중 4DGS+deformation cache 라인 (Park 24 → GS-DiT → 4DGS-Cache)이 구현 가능 경로로 수렴. Sparse-view 3DGS가 2차 라인.</>,
    'proj.impl': '구현 후보',
    'proj.impl.repro': '3주차 재현',
    'proj.impl.inp': '진행 중',
    'proj.impl.blocked': '코드 대기',
    'proj.targets': '벤치마크 목표',
    'proj.psnr': 'PSNR 목표',
    'proj.interactive': '인터랙티브',
    'proj.pose': '포즈',
    'proj.figs': '발표용 저장 그림',
    'col.collected': '수집',
    'col.reading': '읽는 중',
    'col.important': '중요',
    'col.repro': '재현 후보',
    'col.implementing': '구현 중',
    'col.used': '발표 활용',
    'col.archived': '보관',
    'col.empty': '보관된 항목 없음',
    'card.diff': '난이도',

    // graph
    'gr.view': '뷰',
    'gr.v.paper': '논문',
    'gr.v.concept': '개념',
    'gr.v.dataset': '데이터셋',
    'gr.v.author': '저자',
    'gr.edges': '엣지 유형',
    'gr.e.cites': '인용',
    'gr.e.improves': '개선',
    'gr.e.compares': '비교',
    'gr.e.dataset': '같은 데이터셋',
    'gr.e.family': '같은 방법론',
    'gr.e.author': '같은 저자',
    'gr.e.project': '내 프로젝트',
    'gr.filters': '필터',
    'gr.f.strength': '연결 강도 ≥ 0.7',
    'gr.f.bookmark': '북마크만',
    'gr.f.project': '내 프로젝트',
    'gr.f.os': '오픈소스',
    'gr.layout': '레이아웃',
    'gr.l.force': '포스',
    'gr.l.radial': '방사형',
    'gr.l.time': '시간순',
    'gr.depth': '깊이',
    'gr.hops': '중심에서 홉',
    'gr.legend.paper': '논문 · 선택',
    'gr.legend.cited': '피인용',
    'gr.legend.cites': '인용',
    'gr.legend.family': '같은 방법론',
    'gr.legend.project': '내 프로젝트',
    'gr.stats.nodes': '노드',
    'gr.stats.edges': '엣지',
    'gr.stats.hops': '홉',
    'gr.rail.node': '노드',
    'gr.rail.why': '이 노드의 중요성',
    'gr.rail.why.body': () => <>당신이 추적하는 세 가지 스레드 — deformation-field 4DGS, 실시간 렌더링, 3D용 diffusion prior — 의 교차점에 위치. <span style={{ color: 'var(--fg-0)' }}>북마크 14편</span>이 2홉 이내에서 연결됨.</>,
    'gr.rail.conn': '가장 강한 연결',
    'gr.rail.conn.cites': '인용 · 선수',
    'gr.rail.conn.improves': '본 논문을 개선',
    'gr.rail.conn.family': '같은 방법 가족',
    'gr.rail.conn.proj': '내 프로젝트에 포함',
    'gr.rail.ai': 'AI 해석',
    'gr.rail.ai.body': () => <>경로 <span className="mono" style={{ color: 'var(--acc-cyan)' }}>Deformable-3DGS → GS-DiT → 4DGS-Cache</span>는 2025–26년 실시간 동적 Gaussian splatting의 주류 계보. 이 스레드를 채택한다면 4DGS-Cache가 다음 읽기.</>,
    'gr.rail.open': '논문 열기',

    // wiki
    'wk.hierarchy': '계층',
    'wk.new': '새 개념 페이지',
    'wk.kind.concept': '개념',
    'wk.papers': '논문',
    'wk.backlinks': '백링크',
    'wk.curated': '14개 항목 큐레이션',
    'wk.lastedit': '2시간 전 편집',
    'wk.activity.week': '이번 주 활동: +3편',
    'wk.aioverview': 'AI 개요',
    'wk.synth': '14편에서 합성',
    'wk.overview.p1': () => <><span style={{ color: 'var(--fg-0)' }}>Deformation field</span>는 점의 <span className="mono pp-code-inl">canonical position</span>과 시간 <span className="mono pp-code-inl">t</span>를 입력받아 그 시점의 변위를 반환하는 학습된 매핑입니다. <a className="pp-wiki-link" href="#">4D Gaussian Splatting</a> 맥락에서는, 단일 Gaussian 집합이 프레임마다 재적합되지 않고 시간에 따라 변위되는 방식으로 동적 씬을 모델링하게 해줍니다.</>,
    'wk.overview.p2': () => <>주된 정식화는 𝒟를 (a) 작은 MLP <a className="pp-wiki-link" href="#">[Park 24]</a>, (b) 해시 그리드/triplane <a className="pp-wiki-link" href="#">[K-Planes 23]</a>, 또는 (c) 동결된 distilled prior + 씬별 캐시 <a className="pp-wiki-link" href="#">[GS-DiT 26]</a>로 파라미터화합니다. 트레이드오프는 아래에 정리.</>,
    'wk.h.notes': '내 노트',
    'wk.note.body': () => <>변형 파라미터화 선택에서 가장 중요한 변수는 <em>데이터셋마다 prior를 재학습할 수 있는가</em>. 랙 트윈 프로젝트는 그게 불가능합니다 (데이터 제약) — 따라서 <span style={{ color: 'var(--acc-indigo)' }}>frozen-prior + cache</span> 계열(GS-DiT)이 맞고, 씬별 MLP 계열 (Park 24)은 아닙니다. 수식 참조는 Park 24, 시스템 참조는 GS-DiT.</>,
    'wk.edited': '2시간 전 편집',
    'wk.h.formula': '정식 표기',
    'wk.formula.note': 'where 𝒟ᶿ : ℝ³ × ℝ → ℝ³ is the learned deformation',
    'wk.h.cards': '지식 카드',
    'wk.card.primary': 'CVPR 26 · 핵심',
    'wk.card.canonical': 'CVPR 24 · 정식 참조',
    'wk.card.alt': 'CVPR 23 · 대안',
    'wk.card.impl': '구현',
    'wk.card.dataset': '데이터셋',
    'wk.card.gsdit.body': '동결 DiT prior + 4-bit VQ 캐시. D-NeRF에서 84 FPS, 31.74 PSNR.',
    'wk.card.def3dgs.body': '씬별 MLP 𝒟. 대부분 논문이 인용하는 표준 파라미터화.',
    'wk.card.kplanes.body': '𝒟의 triplane 분해. 더 느리지만 메모리 효율적.',
    'wk.card.vq.body': '사전 계산된 변위의 인덱싱 코드북; 프레임당 MLP 호출을 대체.',
    'wk.card.dnerf.body': '8개 동적 씬; 4D NVS의 표준 벤치마크.',
    'wk.card.hyper.body': '동적 씬 캐주얼 캡처; D-NeRF보다 어려움.',
    'wk.h.related': '관련 논문 · 14',
    'wk.h.bench': '관련 벤치마크',
    'wk.h.backlinks': '백링크 · 6',
    'wk.read.read': '읽음',
    'wk.read.reading': '읽는 중',
    'wk.read.queue': '큐',
    'wk.read.skim': '훑음',
    'wk.toc.title': '이 페이지 안에서',
    'wk.toc.overview': '개요',
    'wk.toc.notes': '내 노트',
    'wk.toc.formula': '정식 표기',
    'wk.toc.cards': '지식 카드',
    'wk.toc.related': '관련 논문 · 14',
    'wk.toc.bench': '관련 벤치마크',
    'wk.toc.backlinks': '백링크 · 6',
    'wk.activity': '활동',
    'wk.act.r1': 'GS-DiT §3.2에서 지식 카드 추가',
    'wk.act.r2': 'Park 24 링크',
    'wk.act.r3': '정식 표기 수정',
    'wk.act.r4': '새 메모에서 백링크 3개',

    // assistant
    'as.history': '대화 기록',
    'as.new': '새 대화',
    'as.saved': '저장된 답변',
    'as.conv1': 'VLA 비교 · ALOHA 실로봇',
    'as.conv2': 'GS-DiT는 왜 DiT prior가 필요한가?',
    'as.conv3': '랙 트윈: 4DGS 스레드 읽기 순서',
    'as.conv4': '이번 주 4DGS 논문 요약',
    'as.conv5': '지난달 본 deformation-field 논문',
    'as.conv6': '실내 금속용 최선의 SfM 방법',
    'as.conv7': 'Park 24를 인용한 논문',
    'as.saved1': '비교 표: GS-DiT vs 4DGS-Cache',
    'as.saved2': 'ALOHA 리더보드 요약',
    'as.now': '방금',
    'as.user.q': () => <>서재에서 ALOHA에 대해 <span className="mono pp-code-inl">실로봇</span> 평가를 보고한 VLA 논문들을 비교해줘. 성공률을 보여주고 공정 비교 이슈가 있으면 표시.</>,
    'as.retrieved': '논문 8편 검색',
    'as.benchrows': '벤치마크 3행',
    'as.verified.all': '인용 모두 검증됨',
    'as.lead': () => <>서재에서 ALOHA bimanual을 실로봇 프로토콜(과제당 ≥50 trial)로 평가하는 논문은 3편. 보고된 최고치는 <span style={{ color: 'var(--fg-0)' }}>OpenVLA-2의 71.4%</span>이지만, RoboFM-13B와의 비교는 엄밀하게 공정하지 않습니다 — 아래 공정 비교 노트 참고.</>,
    'as.struct': '구조화된 답변',
    'as.openbench': '벤치마크에서 열기',
    'as.pin': '고정',
    'as.col.method': '방법',
    'as.col.success': '성공률 ↑',
    'as.col.proto': '프로토콜',
    'as.col.code': '코드',
    'as.col.cite': '인용',
    'as.proto.real': '50-trial · 실로봇',
    'as.fair.title': '공정 비교 노트',
    'as.fair.body': () => <>RoboFM-13B의 ALOHA 수치는 4개 과제 서브셋 평균이며, OpenVLA-2는 표준 6-서브셋 분할에서 보고. 6-서브셋 분할로 정규화하면 RoboFM은 <span className="mono" style={{ color: 'var(--fg-0)' }}>0.652</span> — OpenVLA-2가 여전히 우위이나 3.1pt가 아닌 6.2pt 차이.</>,
    'as.trend': () => <>최근 6개월 추세는 명확: <span style={{ color: 'var(--acc-indigo)' }}>스케일 + 임바디먼트 혼합</span>이 단일 임바디먼트 파인튜닝을 능가. OpenVLA-2는 §4.3에서 38-임바디먼트 MoE 헤드 덕분이라고 명시.</>,
    'as.sources': '출처 · 3',
    'as.followups': '후속 질문',
    'as.followups.q1': '사전학습 백본을 제외하면 격차는?',
    'as.followups.q2': '각 방법이 어떤 ALOHA 서브셋에서 약한가?',
    'as.followups.q3': 'OpenVLA-2의 MoE 헤드를 우리 셋업에서 구현 가능한가?',
    'as.addproj': '프로젝트 추가',
    'as.savewiki': '위키로 저장',
    'as.copy': '답변 복사',
    'as.export': '내보내기',
    'as.lib': '서재 · 1,247편',
    'as.scope': '범위: 랙 트윈',
    'as.verified.mode': '검증된 결과만 모드',
    'as.sendkey': '⌘↵ 전송',
    'as.textarea': '이제 Bridge-V3에서 비교하고, 언어 조건 과제만 포함해줘.',
    'as.mode.grounded': '근거 기반',
    'as.mode.explore': '탐색',
    'as.mode.compare': '비교',
    'as.send': '전송',
    'as.retrieval': '검색',
    'as.retrieval.sub': () => <>본 답변의 근거. <span style={{ color: 'var(--acc-indigo)' }}>청크 8개</span>, <span style={{ color: 'var(--acc-indigo)' }}>논문 5편</span>에서 검색 (하이브리드 점수순).</>,
    'as.query': '쿼리 해석',
    'as.q.filters': '필터',
    'as.q.task': '작업',
    'as.q.warnings': '경고',
    'as.q.scope': '범위',
    'as.q.filters.v': 'topic=VLA, dataset=ALOHA, protocol=real-robot',
    'as.q.task.v': '비교 · 벤치마크',
    'as.q.warnings.v': '공정 비교 검사 요청',
    'as.q.scope.v': '서재 + 벤치 메모리',
    'as.conf': '신뢰도',
    'as.conf.grounding': '답변 근거 충실도',
    'as.conf.body': '정량 주장은 모두 검증된 벤치 행에 연결됨.',
  },

  en: {
    // brand / shell
    'brand.tagline': 'Research OS',
    'nav.section.workspace': 'Workspace',
    'nav.section.projects': 'Projects',
    'nav.dashboard': 'Dashboard',
    'nav.explore': 'Explore',
    'nav.library': 'Library',
    'nav.bench': 'Benchmark Memory',
    'nav.projects': 'Projects',
    'nav.graph': 'Knowledge Graph',
    'nav.wiki': 'Research Wiki',
    'nav.reports': 'Reports',
    'nav.assistant': 'AI Assistant',
    'nav.questions': 'My Q&A',
    'nav.integrations': 'Integrations',
    'nav.settings': 'Settings',
    'user.role': 'Robotics · KAIST',

    'cmd.placeholder': 'Ask anything across your library…',
    'cmd.mode': 'semantic',
    'cmd.import': 'Import',
    'cmd.synced': 'Synced · 09:42',

    'crumb.workspace': 'Workspace',
    'crumb.dashboard': 'Dashboard',
    'crumb.explore': 'Explore',
    'crumb.wiki': 'Wiki',
    'crumb.graph': 'Knowledge Graph',
    'crumb.bench': 'Benchmark Memory',
    'crumb.assistant': 'AI Assistant',
    'crumb.newconv': 'New conversation',
    'crumb.projects': 'Projects',

    'dash.greeting': 'Good morning, Uni!',
    'dash.greeting.sub': (a, b, c) => <><span className="mono" style={{ color: 'var(--acc-violet)' }}>{a}</span> new papers since yesterday across your 9 tracked topics. <span className="mono" style={{ color: 'var(--acc-indigo)' }}>{b}</span> match your active projects. <span className="mono" style={{ color: 'var(--acc-cyan)' }}>{c}</span> are flagged "must read" — estimated <span style={{ color: 'var(--fg-0)' }}>52 min</span>.</>,
    'dash.yesterday': 'Yesterday',
    'dash.filters': 'Filters · 6',
    'dash.generate': 'Generate briefing',
    'kpi.new': 'New today',
    'kpi.unread': 'Unread important',
    'kpi.bench': 'Benchmark updates',
    'kpi.citation': 'Citation alerts',
    'kpi.code': 'Code released',
    'kpi.project': 'Project-relevant',
    'kpi.delta.vs': 'vs yest',
    'dash.s1.kicker': '01 / Today',
    'dash.s1.title': 'Must-read queue',
    'dash.s1.sub': 'AI-selected, ordered by relevance × novelty × urgency',
    'dash.s1.count': '3 papers · 52 min',
    'dash.seeall': 'See all',
    'dash.s2.kicker': '02 / Today',
    'dash.s2.title': 'Recommended papers',
    'dash.s2.sub': 'Ordered by closeness to your projects · explanations below',
    'dash.s3.kicker': '03',
    'dash.s3.title': 'Trending topics · 7-day',
    'dash.s3.unit': 'papers/day',
    'dash.s4.kicker': '04',
    'dash.s4.title': 'Code released today',
    'dash.s4.unit': '9 repos',
    'rail.resume.kicker': 'Resume',
    'rail.resume.title': 'Continue reading',
    'rail.resume.where': 'p. 7 / 23 · §3.2 Action tokenization',
    'rail.follow.kicker': 'Follow-up',
    'rail.follow.title': 'Saved · needs follow-up',
    'rail.follow.r1.title': 'Gaussian-Splatting SLAM',
    'rail.follow.r1.reason': 'cited 3 times this week',
    'rail.follow.r2.title': 'MobileVLA: 1.5B on-device',
    'rail.follow.r2.reason': 'v2 released yesterday',
    'rail.follow.r3.title': 'EvalRobotics-v3 protocol',
    'rail.follow.r3.reason': 'new dataset link',
    'rail.pulse.kicker': 'Pulse',
    'rail.pulse.title': 'Weekly momentum',
    'rail.pulse.unit': 'papers / wk',
    'rail.pulse.note': '4DGS up 62%, VLA up 48% w/w',
    'rail.ask.kicker': 'AI',
    'rail.ask.title': 'Ask the assistant',
    'rail.ask.suggest': 'Suggested questions today',
    'rail.ask.q1': 'Compare GS-DiT and 4DGS-Cache on D-NeRF fairly',
    'rail.ask.q2': "What changed in OpenVLA-2 vs v1?",
    'rail.ask.q3': "Summarize this week's 4DGS papers",
    'rail.ask.input': 'Ask across your library…',

    'pc.must': 'must read',
    'pc.code': 'code',
    'pc.code.soon': 'soon',
    'pc.why': 'why',
    'pc.score.worth': 'WORTH',
    'pc.score.novel': 'NOVEL',
    'pc.score.impl': 'IMPL',
    'pc.action.bookmark': 'Bookmark',
    'pc.action.addproject': 'Add to project',
    'pc.action.compare': 'Compare',
    'pc.action.openpdf': 'Open PDF',

    'exp.filters': 'Filters',
    'exp.reset': 'Reset 6',
    'exp.qmode': 'Query mode',
    'exp.qmode.semantic': 'semantic',
    'exp.qmode.keyword': 'keyword',
    'exp.qmode.hybrid': 'hybrid',
    'exp.date': 'Date',
    'exp.topic': 'Topic',
    'exp.topic.selected': '4 selected',
    'exp.venue': 'Venue',
    'exp.method': 'Method',
    'exp.dataset': 'Dataset',
    'exp.signals': 'Signals',
    'exp.signal.os': 'Open-source only',
    'exp.signal.real': 'Real-robot eval',
    'exp.signal.bookmark': 'Bookmarked',
    'exp.signal.unread': 'Unread only',
    'exp.signal.inproj': 'In my projects',
    'exp.scores': 'Scores',
    'exp.score.worth': 'Worth reading',
    'exp.score.novel': 'Novelty',
    'exp.score.impl': 'Impl. value',
    'exp.results': '3 248 results',
    'exp.results.meta': (s) => <>matched in <span className="mono" style={{ color: 'var(--acc-indigo)' }}>{s}</span> · semantic + filters · 4DGS, deformation field, real-robot eval</>,
    'exp.view.cards': 'Cards',
    'exp.view.table': 'Table',
    'exp.sort': 'Sort: relevance × novelty',
    'exp.compare': 'Compare (3)',
    'exp.loadmore': 'Load 3242 more',
    'exp.preview': 'Preview',
    'exp.preview.glance': 'One-glance',
    'exp.preview.worth': 'Worth reading?',
    'exp.eval.relevance': 'Relevance to interests',
    'exp.eval.novelty': 'Novelty',
    'exp.eval.impl': 'Implementation value',
    'exp.eval.signif': 'Research significance',
    'exp.eval.diff': 'Reading difficulty',
    'exp.preview.connect': 'Connection to your work',
    'exp.preview.bench': 'Benchmark snapshot',
    'exp.preview.bench.vs': 'vs SoTA',
    'exp.preview.bench.speedup': '× speedup',
    'exp.preview.open': 'Open detail',

    'det.peer': 'peer-reviewed',
    'det.top': 'top 3% predicted',
    'det.coderel': 'code released',
    'det.openpdf': 'Open PDF reader',
    'det.save': 'Save',
    'det.addproj': 'Add to project',
    'det.compare': 'Compare',
    'det.cite': 'Cite · BibTeX',
    'det.repo': 'Repo',
    'det.tab.overview': 'Overview',
    'det.tab.summary': 'AI Summary',
    'det.tab.why': 'Why recommended',
    'det.tab.critique': 'Critique',
    'det.tab.novelty': 'Novelty',
    'det.tab.qa': 'Q&A (5)',
    'det.tab.related': 'Related papers',
    'det.tab.notes': 'Notes (8)',
    'det.tab.bench': 'Benchmarks (5)',
    'det.tab.code': 'Code',
    'det.tab.proj': 'Project relevance',
    'det.tab.order': 'Reading order',
    'det.eval.title': 'Is this worth reading?',
    'det.eval.sub': 'Structured evaluation against your reading history and projects',
    'det.eval.relevance': 'Relevance',
    'det.eval.novelty': 'Novelty',
    'det.eval.impl': 'Implementation',
    'det.eval.signif': 'Significance',
    'det.eval.impact': 'Likely impact',
    'det.eval.diff': 'Reading difficulty',
    'det.eval.note.rel': '9/10 · close match to server-rack twin',
    'det.eval.note.nov': 'DiT prior + GS deformation is new',
    'det.eval.note.imp': 'Repo + 4090 single-GPU feasible',
    'det.eval.note.sig': 'Sets new D-NeRF SoTA',
    'det.eval.note.impact': 'Est. 240 citations in 18 mo',
    'det.eval.note.dif': 'ML+graphics priors required',
    'det.rec.headline': 'Read it today — high impact for your 4D-recon and rack-twin work.',
    'det.rec.sub': '52 min · skip §4.3 if short on time; §3 and §5.2 carry the contribution.',
    'det.rec.add': 'Add to today',
    'det.why.title': 'Why this paper was recommended',
    'det.why1.title': 'Matches your active project: Server-rack digital twin',
    'det.why1.body': "Handles thin metallic geometry (a known failure mode in your D-NeRF baseline) and reaches 84 FPS — within your 30 Hz interactive twin budget with 2.8× headroom.",
    'det.why2.title': 'Continues a thread in your research wiki: deformation field',
    'det.why2.body': "GS-DiT's canonical-to-frame deformation matches the formulation you annotated in Deformable-3DGS (saved Mar 4) and Park et al. (saved last week).",
    'det.why3.title': '3 of your bookmarked papers cite this work as prior art',
    'det.why3.body': 'OpenVLA-2, RoboFM-13B, 4DGS-Cache (in your reading queue) all reference the GS-DiT deformation cache.',
    'det.why4.title': 'Author Mildenhall is in your follow list',
    'det.why4.body': '4 papers in past 12 mo, avg worth-reading score 0.84.',
    'det.order.title': 'Reading order',
    'det.order.sub': 'What to read before and after, ordered by prerequisite strength',
    'det.order.before': 'Read before',
    'det.order.after': 'Read after',
    'det.order.tag.prereq': 'prerequisite',
    'det.order.tag.prior': 'prior art',
    'det.order.tag.follow': 'follow-up',
    'det.order.tag.crit': 'critique',
    'det.order.tag.app': 'application',
    'det.order.read': 'read',
    'det.order.unread': 'unread',
    'det.order.queue': 'in queue',
    'det.bench.title': 'Related benchmark results',
    'det.bench.open': 'Open in Benchmark Memory',
    'det.bench.col.method': 'Method',
    'det.bench.col.dataset': 'Dataset',
    'det.bench.col.cond': 'Condition',
    'det.bench.col.code': 'Code',
    'det.rail.sum': 'AI summary · 60s',
    'det.rail.conn': 'Connection to your work',
    'det.rail.meth': 'Methodology',
    'det.rail.res': 'Resources',
    'det.rail.training': 'Trains on 28k clips · MVS preprocessing · L1 + LPIPS + flow consistency',

    'rd.diff': 'difficulty 7/10',
    'rd.timeleft': '~18 min left',
    'rd.outline': 'Outline',
    'rd.find': 'Find',
    'rd.figs': 'Figures · 14',
    'rd.outline.btn': 'Outline',
    'rd.pop.high': 'Highlight',
    'rd.pop.simple': 'Explain simply',
    'rd.pop.formula': 'Explain formula',
    'rd.pop.impl': 'Impl. interpretation',
    'rd.pop.related': 'Related work',
    'rd.pop.wiki': 'Save → wiki',
    'rd.pop.proj': 'Add → project',
    'rd.tab.ai': 'AI',
    'rd.tab.notes': 'Notes',
    'rd.tab.high': 'Highlights',
    'rd.tab.figs': 'Figures',
    'rd.tab.tabs': 'Tables',
    'rd.ai.kicker': 'Implementation interpretation',
    'rd.ai.body.lead': 'In code:',
    'rd.ai.body': ' at training time you keep a vanilla MLP $$g_θ(id, t)$$; at the end of training you sweep all (id, t) pairs, quantize outputs to a 4-bit codebook (~64 entries), and store a per-Gaussian index map. Inference becomes a single texture fetch — no MLP forward — which is why FPS jumps 3.1×.',
    'rd.copy': 'Copy',
    'rd.save.wiki': 'Save → wiki',
    'rd.pin.proj': 'Pin to project',
    'rd.formula.kicker': 'Formula · eq. 7',
    'rd.formula.body': 'Canonical position μᶜᵃⁿ plus a per-id, per-time displacement 𝒟. The cache approximates 𝒟 with a codebook lookup.',
    'rd.related.title': 'Related (from this passage)',
    'rd.related.r1': 'cited as Eq. 4 source',
    'rd.related.r2': 'alternative deformation',
    'rd.related.r3': 'extends the cache idea',
    'rd.memo.kicker': 'My memo · 2 min ago',
    'rd.memo.body': 'Try this on rack dataset week 3 — check if 4-bit codebook holds for ≥800 Gaussians in the cable region. Compare against Park 24 baseline.',
    'rd.ask.passage': 'Ask about this passage…',

    'bn.dataset': 'Dataset',
    'bn.task': 'Task',
    'bn.metric': 'Metric',
    'bn.cond': 'Condition',
    'bn.method': 'Method',
    'bn.venue': 'Venue',
    'bn.year': 'Year',
    'bn.all': 'all',
    'bn.any': 'any',
    'bn.code': 'Code available',
    'bn.verified': 'Verified only',
    'bn.real': 'Real-robot only',
    'bn.fair': 'Fair comp.',
    'bn.view.table': 'Table',
    'bn.view.leader': 'Leaderboard',
    'bn.view.compare': 'Compare',
    'bn.results': '87 results',
    'bn.results.sub': 'across 23 papers, 2 datasets, 3 conditions',
    'bn.stat.verified': 'verified',
    'bn.stat.auto': 'auto-extracted',
    'bn.stat.corrected': 'user-corrected',
    'bn.stat.fair': 'fair-comparison warnings',
    'bn.group': 'Group by dataset',
    'bn.export': 'Export CSV',
    'bn.compare3': 'Compare (3)',
    'bn.col.method': 'Method',
    'bn.col.paper': 'Paper',
    'bn.col.metric': 'Metric',
    'bn.col.value': 'Value',
    'bn.col.delta': 'Δ vs best',
    'bn.col.code': 'Code',
    'bn.col.source': 'Source',
    'bn.col.conf': 'Conf',
    'bn.col.status': 'Status',
    'bn.row.results': 'results',
    'bn.status.verified': 'verified',
    'bn.status.corrected': 'corrected',
    'bn.status.fair': 'fair-comp',
    'bn.status.auto': 'auto',
    'bn.rail.detail': 'Result detail',
    'bn.rail.cond': 'Condition · extracted',
    'bn.rail.cond.views': 'Views',
    'bn.rail.cond.frames': 'Frames',
    'bn.rail.cond.res': 'Resolution',
    'bn.rail.cond.split': 'Split',
    'bn.rail.cond.hw': 'Hardware',
    'bn.rail.cond.pre': 'Pretraining',
    'bn.rail.cond.views.v': '8 input views',
    'bn.rail.cond.frames.v': '200 / scene',
    'bn.rail.cond.split.v': 'canonical, D-NeRF v2',
    'bn.rail.cond.hw.v': '1 × RTX 4090',
    'bn.rail.cond.pre.v': '28k clips · 112M params',
    'bn.rail.evidence': 'Source evidence',
    'bn.rail.openpdf': 'View page in PDF reader',
    'bn.rail.fair.kicker': 'Fair-comparison note',
    'bn.rail.fair.body': '4DGS-Cache reports 120 FPS but at 600×600 in their Tbl. 1, not 800×800. Re-rendered at 800×800 the comparable number is 72 FPS, making GS-DiT the fastest at the canonical resolution.',
    'bn.rail.ai': 'AI interpretation',
    'bn.rail.ai.body': 'Improvement comes almost entirely from the diffusion-prior pretraining (+0.9 PSNR, ablated in §5.2), not the canonical-id cache itself (which is speed-only). Replicating without the 28k-clip pretrain corpus should land closer to Def-3DGS.',

    'proj.triaged': '042 / 240 papers triaged',
    'proj.ontrack': 'on track',
    'proj.started': 'started Feb 2025',
    'proj.collab': 'collaborators',
    'proj.newpapers': 'new papers since last visit',
    'proj.benchref': 'benchmark refs linked',
    'proj.add': 'Add paper',
    'proj.askai': 'Ask AI',
    'proj.generate': 'Generate briefing',
    'proj.direction': 'AI summary of direction',
    'proj.direction.body': () => <>Project is centered on <span style={{ color: 'var(--fg-0)' }}>real-time 4DGS for thin metallic geometry</span>. Of 42 triaged papers, the 4DGS+deformation cache thread (Park 24 → GS-DiT → 4DGS-Cache) is converging into a viable implementation path. Sparse-view 3DGS is the secondary thread.</>,
    'proj.impl': 'Implementation candidates',
    'proj.impl.repro': 'repro week 3',
    'proj.impl.inp': 'in progress',
    'proj.impl.blocked': 'blocked on code',
    'proj.targets': 'Benchmark targets',
    'proj.psnr': 'PSNR target',
    'proj.interactive': 'interactive',
    'proj.pose': 'pose',
    'proj.figs': 'Saved figures · presentation',
    'col.collected': 'Collected',
    'col.reading': 'Reading',
    'col.important': 'Important',
    'col.repro': 'Repro candidate',
    'col.implementing': 'Implementing',
    'col.used': 'Used in presentation',
    'col.archived': 'Archived',
    'col.empty': 'Nothing archived yet',
    'card.diff': 'diff',

    'gr.view': 'View',
    'gr.v.paper': 'Paper',
    'gr.v.concept': 'Concept',
    'gr.v.dataset': 'Dataset',
    'gr.v.author': 'Author',
    'gr.edges': 'Edge types',
    'gr.e.cites': 'cites',
    'gr.e.improves': 'improves',
    'gr.e.compares': 'compares with',
    'gr.e.dataset': 'same dataset',
    'gr.e.family': 'same method family',
    'gr.e.author': 'same author',
    'gr.e.project': 'in my project',
    'gr.filters': 'Filters',
    'gr.f.strength': '≥ 0.7 connection strength',
    'gr.f.bookmark': 'Bookmarked only',
    'gr.f.project': 'In my projects',
    'gr.f.os': 'Open-source',
    'gr.layout': 'Layout',
    'gr.l.force': 'force',
    'gr.l.radial': 'radial',
    'gr.l.time': 'time',
    'gr.depth': 'Depth',
    'gr.hops': 'Hops from center',
    'gr.legend.paper': 'Paper · selected',
    'gr.legend.cited': 'Cited',
    'gr.legend.cites': 'Cites',
    'gr.legend.family': 'Same method',
    'gr.legend.project': 'In project',
    'gr.stats.nodes': 'nodes',
    'gr.stats.edges': 'edges',
    'gr.stats.hops': 'hops',
    'gr.rail.node': 'Node',
    'gr.rail.why': 'Why this node matters',
    'gr.rail.why.body': () => <>Sits at the convergence of three threads you actively track: deformation-field 4DGS, real-time rendering, and diffusion priors for 3D. <span style={{ color: 'var(--fg-0)' }}>14 of your bookmarked papers</span> connect within 2 hops.</>,
    'gr.rail.conn': 'Strongest connections',
    'gr.rail.conn.cites': 'cites · prerequisite',
    'gr.rail.conn.improves': 'improves on this',
    'gr.rail.conn.family': 'same method family',
    'gr.rail.conn.proj': 'in project',
    'gr.rail.ai': 'AI interpretation',
    'gr.rail.ai.body': () => <>The path <span className="mono" style={{ color: 'var(--acc-cyan)' }}>Deformable-3DGS → GS-DiT → 4DGS-Cache</span> represents the dominant lineage for real-time dynamic Gaussian splatting in 2025–26. If your project commits to this thread, 4DGS-Cache is the next read.</>,
    'gr.rail.open': 'Open paper',

    'wk.hierarchy': 'Hierarchy',
    'wk.new': 'New concept page',
    'wk.kind.concept': 'concept',
    'wk.papers': 'papers',
    'wk.backlinks': 'backlinks',
    'wk.curated': 'Curated by you · 14 entries',
    'wk.lastedit': 'Last edited 2h ago',
    'wk.activity.week': 'Activity: +3 papers this week',
    'wk.aioverview': 'AI overview',
    'wk.synth': 'synthesized from 14 papers',
    'wk.overview.p1': () => <>A <span style={{ color: 'var(--fg-0)' }}>deformation field</span> is a learned mapping that takes a point's <span className="mono pp-code-inl">canonical position</span> and a time <span className="mono pp-code-inl">t</span> and returns its displacement at that time. In the context of <a className="pp-wiki-link" href="#">4D Gaussian Splatting</a>, it lets a single set of Gaussians model dynamic scenes by being displaced over time rather than re-fit per frame.</>,
    'wk.overview.p2': () => <>The dominant formulations parameterize 𝒟 as either (a) a small MLP <a className="pp-wiki-link" href="#">[Park 24]</a>, (b) a hash-grid or triplane <a className="pp-wiki-link" href="#">[K-Planes 23]</a>, or (c) a frozen distilled prior with per-scene cache <a className="pp-wiki-link" href="#">[GS-DiT 26]</a>. Trade-offs are summarized below.</>,
    'wk.h.notes': 'Your notes',
    'wk.note.body': () => <>The single most important variable when picking a deformation parameterization is whether you can <em>afford to re-train the prior per dataset</em>. For the rack-twin project we can't (data is restricted) — so the <span style={{ color: 'var(--acc-indigo)' }}>frozen-prior + cache</span> family (GS-DiT) is the right call, not the per-scene MLP family (Park 24). Park 24 is the right reference for the math; GS-DiT is the right reference for the system.</>,
    'wk.edited': 'edited 2h ago',
    'wk.h.formula': 'Canonical formulation',
    'wk.formula.note': 'where 𝒟ᶿ : ℝ³ × ℝ → ℝ³ is the learned deformation',
    'wk.h.cards': 'Knowledge cards',
    'wk.card.primary': 'CVPR 26 · primary',
    'wk.card.canonical': 'CVPR 24 · canonical reference',
    'wk.card.alt': 'CVPR 23 · alt',
    'wk.card.impl': 'implementation',
    'wk.card.dataset': 'dataset',
    'wk.card.gsdit.body': 'Frozen DiT prior + 4-bit VQ cache. 84 FPS, 31.74 PSNR on D-NeRF.',
    'wk.card.def3dgs.body': 'Per-scene MLP 𝒟. The reference parameterization most papers cite.',
    'wk.card.kplanes.body': 'Triplane decomposition of 𝒟. Slower, more memory-efficient.',
    'wk.card.vq.body': 'Indexed codebook of pre-computed displacements; replaces per-frame MLP.',
    'wk.card.dnerf.body': '8 dynamic scenes; standard benchmark for 4D NVS.',
    'wk.card.hyper.body': 'Casual capture of dynamic scenes; harder than D-NeRF.',
    'wk.h.related': 'Related papers · 14',
    'wk.h.bench': 'Related benchmarks',
    'wk.h.backlinks': 'Backlinks · 6',
    'wk.read.read': 'read',
    'wk.read.reading': 'reading',
    'wk.read.queue': 'queue',
    'wk.read.skim': 'skim',
    'wk.toc.title': 'On this page',
    'wk.toc.overview': 'Overview',
    'wk.toc.notes': 'Your notes',
    'wk.toc.formula': 'Canonical formulation',
    'wk.toc.cards': 'Knowledge cards',
    'wk.toc.related': 'Related papers · 14',
    'wk.toc.bench': 'Related benchmarks',
    'wk.toc.backlinks': 'Backlinks · 6',
    'wk.activity': 'Activity',
    'wk.act.r1': 'Added knowledge card from GS-DiT §3.2',
    'wk.act.r2': 'Linked Park 24',
    'wk.act.r3': 'Edited canonical formulation',
    'wk.act.r4': '3 backlinks from new memo',

    'as.history': 'History',
    'as.new': 'New',
    'as.saved': 'Saved answers',
    'as.conv1': 'VLA comparison · ALOHA real-robot',
    'as.conv2': 'Why does GS-DiT need DiT priors?',
    'as.conv3': 'Rack-twin: read order for 4DGS thread',
    'as.conv4': "Summarize this week's 4DGS papers",
    'as.conv5': 'Deformation-field paper I saw last month',
    'as.conv6': 'Best SfM method for indoor metal',
    'as.conv7': 'Which papers cite Park 24?',
    'as.saved1': 'Comparison table: GS-DiT vs 4DGS-Cache',
    'as.saved2': 'ALOHA leaderboard summary',
    'as.now': 'now',
    'as.user.q': () => <>Compare VLA papers in my library that report <span className="mono pp-code-inl">real-robot</span> evaluation on ALOHA. Show success rate, and flag any fair-comparison issues.</>,
    'as.retrieved': 'retrieved 8 papers',
    'as.benchrows': '3 benchmark rows',
    'as.verified.all': 'all citations verified',
    'as.lead': () => <>Three papers in your library evaluate on ALOHA bimanual with a real-robot protocol (≥50 trials per task). Best reported is <span style={{ color: 'var(--fg-0)' }}>OpenVLA-2 at 71.4%</span>, but the comparison is not strictly fair against RoboFM-13B — see fair-comparison note below.</>,
    'as.struct': 'structured answer',
    'as.openbench': 'Open in Bench',
    'as.pin': 'Pin',
    'as.col.method': 'Method',
    'as.col.success': 'Success ↑',
    'as.col.proto': 'Protocol',
    'as.col.code': 'Code',
    'as.col.cite': 'Cite',
    'as.proto.real': '50-trial · real',
    'as.fair.title': 'Fair-comparison note',
    'as.fair.body': () => <>RoboFM-13B's ALOHA number averages across 4 task subsets, while OpenVLA-2 reports on the canonical 6-subset split. Re-normalizing RoboFM to the 6-subset split brings it to <span className="mono" style={{ color: 'var(--fg-0)' }}>0.652</span> — OpenVLA-2 still wins, but by 6.2 pts, not 3.1.</>,
    'as.trend': () => <>The trend over the last 6 months is clear: <span style={{ color: 'var(--acc-indigo)' }}>scale + mixture-of-embodiments</span> beats single-embodiment fine-tunes. OpenVLA-2 explicitly attributes its gain to the 38-embodiment MoE head §4.3.</>,
    'as.sources': 'Sources · 3',
    'as.followups': 'Follow-up questions',
    'as.followups.q1': "What's the gap when we exclude pretrained backbones?",
    'as.followups.q2': 'Which ALOHA subset does each method struggle on?',
    'as.followups.q3': "Is OpenVLA-2's MoE head implementable on our setup?",
    'as.addproj': 'Add to project',
    'as.savewiki': 'Save → wiki',
    'as.copy': 'Copy answer',
    'as.export': 'Export',
    'as.lib': 'Library · 1 247 papers',
    'as.scope': 'Scoped to: rack-twin',
    'as.verified.mode': 'verified-only mode',
    'as.sendkey': '⌘↵ to send',
    'as.textarea': 'Now compare them on Bridge-V3 instead, and include language-conditioned tasks only.',
    'as.mode.grounded': 'grounded',
    'as.mode.explore': 'explore',
    'as.mode.compare': 'compare',
    'as.send': 'Send',
    'as.retrieval': 'Retrieval',
    'as.retrieval.sub': () => <>How the assistant grounded this answer. <span style={{ color: 'var(--acc-indigo)' }}>8 chunks</span> retrieved from <span style={{ color: 'var(--acc-indigo)' }}>5 papers</span>, ranked by hybrid score.</>,
    'as.query': 'Query interpretation',
    'as.q.filters': 'filters',
    'as.q.task': 'task',
    'as.q.warnings': 'warnings',
    'as.q.scope': 'scope',
    'as.q.filters.v': 'topic=VLA, dataset=ALOHA, protocol=real-robot',
    'as.q.task.v': 'comparison · benchmark',
    'as.q.warnings.v': 'fair-comparison check requested',
    'as.q.scope.v': 'library + bench memory',
    'as.conf': 'Confidence',
    'as.conf.grounding': 'Answer grounding',
    'as.conf.body': 'All quantitative claims tied to verified bench rows.',
  },
};

// React context — provider supplies { lang, t } to whole app.
const LangContext = React.createContext({ lang: 'ko', t: (k, ...args) => k });

function LangProvider({ lang, children }) {
  const value = React.useMemo(() => {
    const dict = I18N[lang] || I18N.ko;
    const t = (key, ...args) => {
      const v = dict[key];
      if (v === undefined) return key;
      if (typeof v === 'function') return v(...args);
      return v;
    };
    return { lang, t };
  }, [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

function useT() { return React.useContext(LangContext); }

export { I18N, LangContext, LangProvider, useT };
